import { PopoverPosition as BlueprintPopoverPosition } from '@blueprintjs/core';
import * as React from 'react';
import {
  Button,
  ButtonProps,
  Tooltip,
} from 'vet-bones/design-system/components';

type ProjectDiagramToolbarButtonProps = Pick<
  ButtonProps,
  | 'children'
  | 'className'
  | 'disabled'
  | 'leftIcon'
  | 'onClick'
  | 'rightIcon'
  | 'testId'
> & {
  tooltip?: string;
};

export const ProjectDiagramToolbarButton: React.VFC<
  ProjectDiagramToolbarButtonProps
> = ({
  children,
  className,
  disabled,
  leftIcon,
  onClick,
  rightIcon,
  testId,
  tooltip,
}) => (
  <Tooltip
    description={tooltip}
    disabled={!tooltip}
    position={BlueprintPopoverPosition.TOP}
  >
    <Button
      className={className}
      disabled={disabled}
      leftIcon={leftIcon}
      onClick={onClick}
      rightIcon={rightIcon}
      size="sm"
      testId={testId}
      variant="ghost-gray"
    >
      {children}
    </Button>
  </Tooltip>
);
